export default __webpack_public_path__ + "static/media/phone.ef86e22a.svg";